(() => {
  function init() {
    const bar = document.querySelector('[data-nutracene-sticky-cart]');
    const section = document.querySelector('[id^="MainProduct-"]');
    if (!bar || !section || bar.dataset.initialised) return;
    const main = section.querySelector('button[id^="ProductSubmitButton-"]');
    const form = main?.form;
    if (!main || !form) return;
    bar.dataset.initialised = 'true';
    const variants = JSON.parse(bar.querySelector('[data-sticky-variants]').textContent);
    const select = bar.querySelector('[data-sticky-plan]');
    const add = bar.querySelector('[data-sticky-add]');
    const price = bar.querySelector('[data-sticky-price]');
    const detail = bar.querySelector('[data-sticky-detail]');
    const quantityLabel = bar.querySelector('[data-sticky-quantity]');
    const optionLabel = bar.querySelector('[data-sticky-option-label]');
    const mobileOptionLabel = bar.querySelector('[data-sticky-option-label-mobile]');
    const addLabel = bar.querySelector('[data-sticky-add-label]');
    const daily = bar.querySelector('[data-sticky-daily]');
    const error = bar.querySelector('[data-sticky-error]');
    const subscription = section.querySelector('#subscription_plan_1');
    const onetime = section.querySelector('#subscription_plan_2');
    const frequency = section.querySelector('.custom_subscription_plans select');
    let frame;
    let submitting = false;
    const clean = (text) => (text || '').replace(/\s+/g, ' ').trim();
    function setText(el, value) { if (el.textContent !== value) el.textContent = value; }
    function sync() {
      const variant = variants[form.querySelector('[name="id"]')?.value];
      const planId = frequency?.selectedOptions[0]?.dataset.sellingPlanId;
      const hasPlans = Boolean(variant && Object.keys(variant.plans).length && planId);
      const subscriptionOption = select.querySelector('[value="subscription"]');
      subscriptionOption.disabled = !hasPlans;
      if (subscriptionOption.hidden !== !hasPlans) subscriptionOption.hidden = !hasPlans;
      if (!hasPlans && subscription?.checked && onetime) onetime.click();
      const isSubscription = hasPlans && Boolean(subscription?.checked);
      const mode = isSubscription ? 'subscription' : 'onetime';
      if (select.value !== mode) select.value = mode;
      bar.dataset.mode = mode;
      const bundle = section.querySelector('.bundle_button.active');
      const quantity = isSubscription ? 1 : Number(bundle?.dataset.bundleQuantity || form.querySelector('[name="quantity"]')?.value || 1);
      const bottles = `${quantity} ${quantity === 1 ? 'bottle' : 'bottles'}`;
      const subPrice = variant?.plans[planId] || clean(section.querySelector('.sale__price')?.textContent);
      const bundlePrice = bundle?.querySelector('[data-discount-price]')?.dataset.discountPrice || bundle?.querySelector('[data-price]')?.dataset.price;
      const shownPrice = isSubscription ? subPrice : bundlePrice || variant?.price || '';
      const supplyDays = quantity * 30;
      const dailyPence = Math.round(Number(shownPrice.replace(/[^0-9.,-]/g, '').replace(/,/g, '')) * 100 / supplyDays);
      const dailyText = Number.isFinite(dailyPence) && dailyPence > 0
        ? (dailyPence < 100 ? `${dailyPence}p / serving` : `£${(dailyPence / 100).toFixed(2)} / serving`) : '';
      setText(optionLabel, isSubscription ? 'Subscribe & Save 20%' : 'One-time purchase');
      setText(mobileOptionLabel, isSubscription ? 'Subscribe & Save' : 'One Time');
      setText(daily, dailyText);
      const frequencyText = clean(frequency?.selectedOptions[0]?.textContent).replace(/^Delivery\s+/i, '').replace(/\s*[-–]?\s*Save\s*20%/i, '').trim();
      setText(price, shownPrice);
      setText(quantityLabel, bottles);
      setText(detail, isSubscription ? `${shownPrice} ${frequencyText || 'every month'} · ${bottles}` : `Single purchase · ${bottles}`);
      const busy = main.classList.contains('loading') || main.getAttribute('aria-disabled') === 'true';
      add.disabled = main.disabled || busy || submitting;
      const buttonLabel = busy || submitting ? 'ADDING…' : clean(main.querySelector('span')?.textContent || main.textContent).toUpperCase();
      setText(addLabel, buttonLabel);
      if (price.hidden !== (buttonLabel !== 'ADD TO CART')) price.hidden = buttonLabel !== 'ADD TO CART';
      const errorWrapper = section.querySelector('.product-form__error-message-wrapper');
      const mainError = errorWrapper && !errorWrapper.hidden ? clean(errorWrapper.querySelector('.product-form__error-message')?.textContent) : '';
      setText(error, mainError);
      if (error.hidden !== !mainError) error.hidden = !mainError;
    }
    function visible(el) {
      if (!el || el.hidden || el.closest('[aria-hidden="true"],details:not([open])')) return false;
      const style = getComputedStyle(el);
      const rect = el.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
    }
    function updateVisibility() {
      const rect = main.getBoundingClientRect();
      const inView = rect.bottom > 0 && rect.top < window.innerHeight;
      const overlay = [...document.querySelectorAll('cart-drawer.active, .drawer.active, [data-nutracene-ingredients-dialog]:not([hidden]), product-modal[open], details.menu-drawer-container[open], [role="dialog"][aria-modal="true"]')].some(visible);
      const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * .75;
      const show = !inView && !overlay && !keyboard;
      if (bar.hidden === show) bar.hidden = !show;
      if (document.body.classList.contains('nutracene-sticky-cart-visible') !== show) document.body.classList.toggle('nutracene-sticky-cart-visible', show);
      if (show) document.body.style.setProperty('--nutracene-sticky-cart-height', `${bar.offsetHeight}px`);
    }
    function refresh() {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = null; sync(); updateVisibility(); });
    }
    select.addEventListener('change', () => {
      (select.value === 'subscription' ? subscription : onetime)?.click();
      refresh();
    });
    add.addEventListener('click', () => {
      if (add.disabled || submitting || main.disabled) return;
      submitting = true;
      sync();
      main.click();
      // The existing product form owns the request, errors and cart drawer.
      submitting = false;
      refresh();
    });
    section.addEventListener('change', refresh);
    section.addEventListener('click', refresh);
    new MutationObserver(refresh).observe(section, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value','hidden']});
    new MutationObserver(refresh).observe(document.body, {subtree:true,attributes:true,attributeFilter:['class','open','hidden','aria-hidden']});
    new IntersectionObserver(refresh, {threshold:[0,1]}).observe(main);
    new ResizeObserver(refresh).observe(bar);
    window.addEventListener('scroll', refresh, {passive:true});
    window.addEventListener('resize', refresh, {passive:true});
    window.visualViewport?.addEventListener('resize', refresh, {passive:true});
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

